import DialogActions from '@mui/material/DialogActions';
import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import { Paper, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, Button, Box, IconButton } from "@mui/material"
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import axios from "axios";
import Swal from 'sweetalert2'
import Loading from "../Loading/Loading";
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import localeData from "dayjs/plugin/localeData";
import InfoIcon from '@mui/icons-material/Info';
import 'dayjs/locale/en-gb'
dayjs.extend(localeData);
dayjs.locale("en-gb");

const Timesheets = () => {
    let navigate = useNavigate();
    const [hasLoadedData, setHasLoadedData] = useState(false);
    const [rows, setRows] = useState([]);
    const [disabledDays, setDisabledDays] = useState([]);
    const [dateValue, setDateValue] = useState(dayjs(new Date().toISOString()));
    // const [dateValue, setDateValue] = useState(dayjs(new Date("2023/02/28").toISOString()));
    const [selectedDate, setSelectedDate] = useState(dayjs(new Date().toISOString()));
    const [isDatePickerOpen, setDatePickerOpen] = useState(false);
    const [isLoading, setLoading] = useState(true);

    const [pickerKey, setPickerkey] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            if (!hasLoadedData) {
                try {
                    let response = await axios.get('/api/timesheets');
                    if (response.data.length !== 0) {
                        setRows(processRows(response.data));
                    }
                    let summaryData = await axios.get("/api/summary");
                    let daysCreated = summaryData.data.daysCreated;
                    let modifiedDaysCreated = [];
                    daysCreated.forEach(item => {
                        let day = item.split("T")[0]
                        modifiedDaysCreated.push(day);
                    })

                    let now = new Date();
                    let selectedDate;
                    if (!modifiedDaysCreated.includes(now.toISOString().split('T')[0]) && (now.getDate() === 1 || now.getDay() === 1)) {
                        selectedDate = now.toISOString().split('T')[0];
                    } else {
                        let tmp = getNextDateToTry(now);
                        while (modifiedDaysCreated.includes(tmp.toISOString().split('T')[0])) {
                            tmp = getNextDateToTry(tmp);
                        }
                        selectedDate = tmp;
                    }
                    if (typeof(selectedDate) === 'object') {
                        setDateValue(dayjs(selectedDate.toISOString()));
                    } else {
                        setDateValue(dayjs(new Date(selectedDate).toISOString()));
                    }

                    setDisabledDays(modifiedDaysCreated);
                    setLoading(false);
                    setHasLoadedData(true);
                } catch (ex) {
                    localStorage.setItem(Date.now(), JSON.stringify(ex));
                    console.log(ex)
                    alert("Something went wrong. Please try refreshing");
                }
            }
        }
        try {
            fetchData();
        } catch (err) {
            console.log(err)
        }
    }, []);

    const disableDays = params => {
        if ((params.$D === 1 || params.$W === 1) && !disabledDays.includes(params.$d.toISOString().split("T")[0])) {
            return false;
        } else {
            return true;
        }
    }

    const getNextDateToTry = dateToTry => {
        var d = new Date(dateToTry);
        d.setDate(d.getDate() + (((1 + 7 - d.getDay()) % 7) || 7));

        if (d.getMonth() !== dateToTry.getMonth()) {
            d = new Date(dateToTry.getFullYear(), dateToTry.getMonth() + 1, 1);
        }
        return d;
    }

    const processRows = rows => {
        let sorted = rows.sort(function (a, b) { return new Date(b.date) - new Date(a.date); });
        let formattedRows = [];
        let tmp = [];
        let currentMonth = sorted[0].month;
        sorted.forEach(row => {
            if (row.month === currentMonth) {
                tmp.push(row);
            } else {
                formattedRows.push(tmp);
                currentMonth = row.month;
                tmp = [];
                tmp.push(row);
            }
        })

        if (tmp.length > 0) {
            formattedRows.push(tmp)
        }
        return formattedRows;
    }

    if (isLoading) {
        return <Loading />
    } else {
        return (
            <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={3} style={{ width: 400 }}>
                        <Fragment key={`picker-${pickerKey}`}>
                            <MobileDatePicker
                                label="Pick a date for a week to create"
                                open={isDatePickerOpen}
                                onClose={() => setDatePickerOpen(false)}
                                shouldDisableDate={dateParam => disableDays(dateParam)}
                                inputFormat="DD/MM/YYYY"
                                value={dateValue}
                                onChange={newValue => setDateValue(newValue)}
                                renderInput={(params) => null}
                                components={{
                                    ActionBar: () =>
                                        <DialogActions>
                                            <Button
                                            color="secondary"
                                                style={{marginRight: 40, color: "#29b6f6"}}
                                                onClick={(event) => {
                                                    setDatePickerOpen(false);
                                                }}>Cancel</Button>
                                            <Button
                                                onClick={(event) => {
                                                    axios.post('/api/createNewWeekByDate', { date: dateValue.format('YYYY-MM-DD') })
                                                        .then(function (response) {
                                                            navigate(`/timesheet?id=${response.data.id}`);
                                                        })
                                                        .catch(function (error) {
                                                            Swal.fire({
                                                                title: 'Error',
                                                                html: error.message,
                                                                icon: 'error',
                                                                confirmButtonText: 'Ok'
                                                            })
                                                        });
                                                }}>Create timesheet</Button>
                                        </DialogActions>,
                                }}
                            />
                        </Fragment>
                    </Stack>
                </LocalizationProvider>

                {rows.length > 0 && (
                    <TableContainer>
                        <Table sx={{ width: "100%" }} >
                            <TableHead>
                                <TableRow style={{ backgroundColor: "#f8f9fa" }}>
                                    <TableCell style={{ fontSize: 13, fontWeight: "bold", width: 1 }}>Week</TableCell>
                                    <TableCell style={{ fontSize: 13, fontWeight: "bold" }}>Period</TableCell>
                                    <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="right">Hours</TableCell>
                                    <TableCell style={{ fontSize: 13, fontWeight: "bold", width: 1 }} align="right">Remaining</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                )}
                {rows.length > 0 && (rows.map((formattedRows, i) => (
                    <TableContainer key={i}>
                        <hr className="hr-text" data-content={`${rows[i][0].month.charAt(0).toUpperCase() + rows[i][0].month.slice(1)} ${rows[i][0].year}`} />
                        <Table sx={{ width: "100%", marginBottom: 3 }} key={i}>
                            <TableBody>
                                {formattedRows.length > 0 && (formattedRows.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        onClick={() => navigate(`/timesheet?id=${row.id}`, { replace: false })}
                                        style={row.status === "Submitted" || row.status === "Approved" || row.status === "Pending" ? { backgroundColor: "#c3e6cb" } : { backgroundColor: "#f5c6cb" }}>
                                        <TableCell component="th" scope="row" style={{ width: 1 }}>{row.weekNo}</TableCell>
                                        <TableCell component="th" align="left" scope="row" style={{ minWidth: 160 }}>{row.periodWithWeekdays}</TableCell>
                                        <TableCell align="right" >{row.totalRegisteredHours}</TableCell>
                                        <TableCell align="right" style={{ width: 80 }}>{row.remainingHours}</TableCell>
                                    </TableRow>
                                )))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )))
                }

                {
                    rows.length === 0 && (
                        <div style={{ display: 'flex', alignItems: "center", width: "90%", marginLeft: "5%", marginTop: "50%" }}>
                            <InfoIcon fontSize="large" style={{ marginRight: 10, color: "rgb(119, 198, 110)" }} />
                            <p>Press the green button in the lower right corner to create a new timesheet.</p>
                        </div>
                    )
                }

                <Fab style={{ backgroundColor: "rgb(119, 198, 110)", color: "white", marginLeft: 20 }} className="fab" onClick={() => setDatePickerOpen(true)}>
                    <AddIcon />
                </Fab>
            </div >
        );
    }

};

export default Timesheets;
